import React, { useState, useEffect, useCallback } from 'react';
import { Header } from '../Components/Header'
import { HeroSection } from '../Components/HeroSection'
import { ProductFilters } from '../Components/ProductFilters'
import { TireCard, Tire } from '../Components/TireCard'
import { ShoppingCart, CartItem } from '../Components/ShoppingCart'
import { ServicesSection } from '../Components/ServicesSection'
import { Pagination } from '../Components/Paginator'
import { MessageDialog } from '../Components/MessageDialog'
import { CatalogItem, CatalogItemListReq, PropertyFilter } from '../types/catalog'; // Adjust path if needed
import { catalogClient } from '../services/grpc'; // Adjust path to your gRPC client
import { propetylistReq,CartAddReq,CartRemoveReq,CartRes,OrderAcceptRes,OrderAcceptReq } from '../generated/catalog_pb'; // From generated proto (adjust path)
import { PropertyFilter as GrpcPropertyFilter,CatalogItemListReq as GrpcCatalogItemListReq } from '../generated/catalog_pb'; // Import generated type
import { useNavigate, useParams } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import Cookies from 'js-cookie';
import Carfilter from '../Components/carfilter';
import type { TireSizeSelection } from '../Components/carfilter';
export const  TirePage: React.FC = () => {
  const [width, setWidth] = useState('');
  const [height, setProfile] =useState('');
  const [diameter, setDiameter] = useState('');
  const [season, setSeason] = useState('');
  const [thorn, setThorn] = useState('');
  const [sortConfig, setSortConfig] = useState("name asc");
  const [brand, setBrand] = useState('');
  const [ProfileOptions, setProfileOptions] =useState<string[]>([]);
  const [widthOptions, setWidthOptions] = useState<string[]>([]); // State for dynamic width options
  const [rOptions,setROptions] = useState<string[]>([]);
  const [BrandOptions,setBrandOptions] = useState<string[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<string[]>([]);
  const navigate = useNavigate();
  const [items, setItems] = useState<CatalogItem[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [itemsToShow, setItemsToShow] = useState(0) 
  const [page, setPage] = useState(1);
  const [limit] = useState(12);
  const [pageCount, setPageCount] = useState(0); 
  const [currentPage, setCurrentPage] = useState(0); 
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [loadingOrder, setLoadingOrder] = useState(false);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [nameSortOrder, setNameSortOrder] = useState('asc');  
  const [priceSortOrder, setPriceSortOrder] = useState(''); 
  const handleCarTireSizeSelect = useCallback(
    (size: TireSizeSelection | null) => {
      if (!size) {
        setWidth('')
        setProfile('')
        setDiameter('')
        return
      }

      setWidth(size.width)
      setProfile(size.height)
      setDiameter(size.diameter)
    },
    [setDiameter, setProfile, setWidth],
  )
  let filterwidth= useParams<"width">();
  let filterbrand= selectedBrands;
  let filterseason= useParams<"season">();
  let filterprofile= useParams<"height">();
  let filterthorn='all';
  let filterpuncture= 'all';
  const [filters, setFilters] = useState<CatalogItemListReq>({
    catalog_code: '',
    prop_filters: [],
    page: 1,
    limit: 12, // Items per page
  });
   const makeFilter = (code: string, command: string, val: unknown) => {
    if (val === undefined || val === null) return null;
    let s = '';
    if (Array.isArray(val)) s = val.join('_');
    else s = String(val).trim();
    if (!s || s.toLowerCase() === 'all') return null;

    const pf = new GrpcPropertyFilter();
    pf.setCode(code);
    pf.setCommand(command);
    pf.setSearch(s);
    return pf;
  };
  useEffect(() => {
    // Fetch width options from gRPC on component mount
    const pListReq = new propetylistReq();
    pListReq.setPropertyCode("width");

    catalogClient.getPropertyList(pListReq, {}, (err, response) => {
      if (err) {
        console.error('Error fetching width options:', err.code, err.message);
        // Fallback to static options if needed
        setWidthOptions(['Не важно']);
      } else if (response) {
        // Map gRPC response to array of strings
        const options = response.getValueList();
        setWidthOptions(options);
      }
    });
    const rListReq = new propetylistReq();
    rListReq.setPropertyCode("diameter");

    catalogClient.getPropertyList(rListReq, {}, (err, response) => {
      if (err) {
        console.error('Error fetching width options:', err.code, err.message);
        setROptions(['Не важно']);
      } else if (response) {
        const options = response.getValueList();
        setROptions(options);
      }
    });

    rListReq.setPropertyCode("height");
    catalogClient.getPropertyList(rListReq, {}, (err, response) => {
      if (err) {
        console.error('Error fetching width options:', err.code, err.message);
        setProfileOptions(['Не важно']);
      } else if (response) {
        const options = response.getValueList();
        setProfileOptions(options);
      }
    });
    rListReq.setPropertyCode("brand");
    catalogClient.getPropertyList(rListReq, {}, (err, response) => {
      if (err) {
        console.error('Error fetching width options:', err.code, err.message);
      } else if (response) {
        const options = response.getValueList();
        setBrandOptions(options);
      }
    });
    fetchProducts();
  }, [filters]); 
   useEffect(() => {
    fetchProducts();
  }, [
    selectedBrands, 
    width,
    height,
    diameter,
    season,
    thorn,
    currentPage,
    limit,
    sortConfig
  ]);


  const handleFind = () => {
   
    var filterwidth=width!='' ? width : 'all';
    var filterbrand=selectedBrands.length>0 ? selectedBrands.join("_") : 'all';
    var filterseason=season!='' ? season : 'all';
    var filterprofile=height!='' ? height : 'all';
    var filterdiameter=diameter!='' ? diameter : 'all';
    var filterthorn='all';
    var filterpuncture= 'all';
    navigate(`/catalog/tire/${selectedBrands.length>0 ? selectedBrands.join("_") : 'all'}/${filterseason}/${filterwidth}/${filterprofile}/${filterdiameter}/${filterthorn}/${filterpuncture}`);
  };
const toggleBrand = (brand: string) => {
  setSelectedBrands(prev =>
    prev.includes(brand)
      ? prev.filter(b => b !== brand)
      : [...prev, brand]
  );
};
  
  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const grpcReq = new GrpcCatalogItemListReq();
      const filters: GrpcPropertyFilter[] = [];
      const boolStr = (v: string) =>
        v.toLowerCase() === 'yes' ? 'true' : v.toLowerCase() === 'no' ? 'false' : v;
      if (selectedBrands.length>0) {
      const grpcBrend:any=makeFilter('brand', 'in', selectedBrands);
      filters.push(grpcBrend);
      }
      if (width) {
      const grpcwidth:any=makeFilter('width', 'in', width);
      filters.push(grpcwidth);
      }
       if (height) {
      const grpcprofile:any=makeFilter('height', 'in', height);
      filters.push(grpcprofile);
      }
       if (season) {
      const grpcseason:any=makeFilter('season', 'in', season);
      filters.push(grpcseason);
      }
       if (diameter) {
      const grpcdiameter:any=makeFilter('diameter', 'in', diameter);
      filters.push(grpcdiameter);
      }
      if (thorn&&thorn!="all"&&season=="w") {
        const grpcthorn:any=makeFilter('thorn', '=', thorn=="yes" ?   "true" : "false" );
        filters.push(grpcthorn);
        }
      grpcReq.setPage(currentPage);
      grpcReq.setLimit(limit);
      grpcReq.setPropFiltersList(filters);
      grpcReq.setOrder(sortConfig);
      catalogClient.getCatalogItemList(grpcReq, {}, (err, response) => {
        if (err) {
          console.error('Error fetching products:', err.code, err.message);
          setError(`Failed to load products: ${err.message}`);
        } else if (response) {
          const mappedItems: CatalogItem[] = response.getItemsList().map(item => ({
            code: item.getCode(),
            name: item.getName(),
            desc: item.getDesc(),
            title: item.getTitle(),
            pic: item.getPic(),
            id:item.getId(),
            price:item.getPrice(),
            qty:item.getQty(),
            props: {
              prop: item.getProps()?.getPropList().map(p => ({
                code: p.getCode(),
                name: p.getName(),
                value: p.getValue(),
              })) || []
            }
          }));
          setItems(mappedItems);
          setTotalCount(response.getCnt());
          setTotalPages(response.getTotalPages());
          setPageCount(Math.ceil(totalPages / limit));
        }
        setLoading(false);
      });
    } catch (err) {
      console.error('Unexpected error:', err);
      setError('An unexpected error occurred.');
      setLoading(false);
    }
  };
  const handleCloseAlert = () => {
    setAlertMessage(null);
};

  const [cartItems, setCartItems] = useState<CartItem[]>([])
  const [isCartOpen, setIsCartOpen] = useState(false)
  const [isopenDialog, setOpenDialog] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState('all')
  const addToCart = (tire: CatalogItem) => {
    try {
      const guid = Cookies.get('guid');
      if (typeof guid === 'string') {
        const req = new CartAddReq();
        req.setGuid(guid);
        req.setProductId(tire.id);
        req.setQty(tire.qty);
        catalogClient.cartAdd(req, {}, (err, response) => {
          if (err) {
            console.error('Error adding to cart:', err.code, err.message);
          }
        });
      }
      setCartItems(prev => {
        const safeCartItems = prev || []
        const existingItem = safeCartItems.find(item => item.tire.id === tire.id)
        if (existingItem) {
          return safeCartItems.map(item =>
            item.tire.id === tire.id 
              ? { ...item, quantity: item.quantity + 1 }
              : item
          )
        }
        return [...safeCartItems, { tire, quantity: 1 }]
      })
    } catch (error) {
      console.error('Error adding to cart:', error)
    }
  }

  const updateQuantity = (tireId: number, quantity: number) => {
    try {
      if (quantity === 0) {
        removeFromCart(tireId)
        return
      }
      const guid = Cookies.get('guid');
      if (typeof guid === 'string') {
        const req = new CartAddReq();
        req.setGuid(guid);
        req.setProductId(tireId);
        req.setQty(quantity);
        catalogClient.cartAdd(req, {}, (err, response) => {
          if (err) {
            console.error('Error adding to cart:', err.code, err.message);
          }
        });
      }
      setCartItems(prev => {
        const safeCartItems = prev || []
        return safeCartItems.map(item =>
          item.tire.id === tireId ? { ...item, quantity } : item
        )
      })
    } catch (error) {
      console.error('Error updating quantity:', error)
    }
  }
 
  const removeFromCart = (tireId: number) => {
    try {
      const guid = Cookies.get('guid');
      if (typeof guid === 'string') {
      const req = new CartRemoveReq();
      req.setGuid(guid);
      req.setProductId(tireId);
      req.setQty(0);
      catalogClient.cartRemove(req, {}, (err, response) => {
        if (err) {
          console.error('Error removing from cart:', err.code, err.message);
        }
      });
    }
      setCartItems(prev => {
        const safeCartItems = prev || []
        return safeCartItems.filter(item => item.tire.id !== tireId)
      })
    } catch (error) {
      console.error('Error removing from cart:', error)
    }
  }
  const setOrder = ()=>{
    if (!customerName || !customerPhone) {
      setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
      return;
  }

    const guid = Cookies.get('guid');
    if (typeof guid === 'string') {
      const req=new OrderAcceptReq();
      req.setGuid(guid);
      req.setName(customerName);
      req.setPhone(customerPhone);
      catalogClient.orderAccept(req, {}, (err, response) => {
        if (err) {
          console.error('Error removing from cart:', err.code, err.message);
        } else {
        if (response.getStatus()=="fail") { 
          setAlertMessage(`${response.getMessage()}`);
        } else {
          setAlertMessage(`Спасибо за заказ.\n\ 
            В ближайшее время наш менеджер свяжется с Вами.\n\ 
            Номер вашего заказа: ${response.getNum()}`);
          setCartItems([]);
          setIsCartOpen(false);
        }
          return;
        }
      });
    }
  }
   const handlePageChange = (selectedItem: { selected: number }) => {
    setCurrentPage(selectedItem.selected + 1)
    // Scroll to top of page smoothly when changing pages
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const totalCartItems = Array.isArray(cartItems) ? cartItems.reduce((sum, item) => sum + item.quantity, 0) : 0
  return (
    <div className="min-h-screen bg-gray-50">
      <Header 
        cartItemCount={totalCartItems} 
        onCartClick={() => setIsCartOpen(true)} 
      />
      
      <HeroSection />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <section id="products" className="mb-16">
          <div className="text-center mb-8">
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-1">
             
              <ProductFilters
                onThornChange={setThorn}
                widthOptions={widthOptions}
                ProfileOptions={ProfileOptions}
                rOptions={rOptions}
                BrandOptions={BrandOptions}
                selectedCategory={selectedCategory}
                selectedSeason={season}
                selectedThorn={thorn}
                onSeasonChange={setSeason}
                selectedBrands={selectedBrands}
                onBrandChange={setSelectedBrands}
                selectedWidth={width}
                onWidthChange={setWidth}
                selectedHeight={height}
                onHeightChange={setProfile}
                selectedRadius={diameter}
                onRadiusChange={setDiameter}
                onTireSizeSelect={handleCarTireSizeSelect}
              />
            </div>
            <div className="lg:col-span-3">
              <div className="mb-4">
                <p className="text-sm text-gray-600">
                  Показано {items.length} из  
                  {totalCount && (
                    <span className="ml-2 text-[#ed8510]">
                      {totalCount}
                    </span>
                  )}
                </p>
                 <div className="sort-controls">
        <a
          href="#"
          onClick={(e) => setSortConfig(sortConfig === 'name asc' ?'name desc':'name asc')}
          className={sortConfig === 'name asc'||sortConfig === 'name desc' ? 'active' : ''}
        >
          по имени {sortConfig === 'name asc' ? '  ↑' : sortConfig==='name desc' ?'  ↓':''}
        </a>
        <a
          href="#"
          onClick={(e) => setSortConfig(sortConfig === 'price asc' ?'price desc':'price asc')}
          className={sortConfig === 'price asc'||sortConfig === 'price desc' ? 'active' : ''}
        >
          по цене {sortConfig === 'price asc' ? '  ↑' : sortConfig==='price desc' ?'  ↓':''}
        </a>
      </div>

              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                {items.map(tire => (
                  <TireCard
                    key={tire.code}
                    tire={tire}
                    onAddToCart={addToCart}
                  />
                ))}
              </div>
                {totalCount && (
                <div className="flex justify-center mt-8">
                 {!loading && items.length > 0 && (
             <Pagination 
  pageCount={totalPages} 
  currentPage={currentPage}
  onPageChange={(selectedPage) => {
    setCurrentPage(selectedPage); 
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }} 
/>
        )}
                </div>
              )}
              {items.length === 0 && (
                <div className="text-center py-12">
                  <p className="text-gray-500">Нет шин удовлетворящих ваш критерий выбора</p>
                </div>
              )}
            </div>
          </div>
        </section>
      </main>
      
      <ServicesSection />
      
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="font-bold text-lg mb-4 text-[#ed8510]"><img className="t454__imglogo t454__imglogomobile" src="https://intershina.pro/images/logo_bottom.png"  alt="Интершина"/></h3>
              <p className="text-gray-400"></p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Работаем для Вас:</h4>
              <ul className="space-y-2 text-gray-400">
                <li className=" hover:text-[#ed8510] transition-colors cursor-pointer">Понедельник-суббота:</li>
                <li className="font-bold hover:text-[#ed8510] transition-colors cursor-pointer">10-00 до 19-00</li>
                <li className=" hover:text-[#ed8510] transition-colors cursor-pointer">Воскресенье</li>
                <li className="font-bold hover:text-[#ed8510] transition-colors cursor-pointer">10-00 до 15-00</li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Services</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="hover:text-[#ed8510] transition-colors cursor-pointer">Шиномонтаж</li>
                <li className="hover:text-[#ed8510] transition-colors cursor-pointer">Балансировка колёс</li>
                <li className="hover:text-[#ed8510] transition-colors cursor-pointer">Ремонт дисков</li>
                <li className="hover:text-[#ed8510] transition-colors cursor-pointer">Сезонное хранение колёс</li>
              </ul>
            </div>
            <div id="contact">
              <h4 className="font-semibold mb-4">Contact</h4>
              <div className="space-y-2 text-gray-400">
                <p className="hover:text-[#ed8510] transition-colors">+7(812)985-13-11 </p>
                <p className="hover:text-[#ed8510] transition-colors">+7(81371)76-431</p>
                <p>Ленинградская обл., г. Гатчина<br/> ул. Карла Маркса 63 "б"</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 WideVision.tech. All rights reserved.</p>
          </div>
        </div>
      </footer>
      
      {/* Only render ShoppingCart when cartItems is properly initialized */}
      {Array.isArray(cartItems) && (
        <ShoppingCart
          isOpen={isCartOpen}
          onOpenChange={setIsCartOpen}
          cartItems={cartItems}
          onUpdateQuantity={updateQuantity}
          onRemoveItem={removeFromCart}
          onOrder={setOrder}
          customerName={customerName}
          customerPhone={customerPhone}
          setCustomerName={setCustomerName}
          setCustomerPhone={setCustomerPhone}
        />
      )}
       <MessageDialog
                title=""
                message={alertMessage || ""} // Pass the error message
                open={alertMessage !== null} // Open if a message exists
                onClose={handleCloseAlert}
                confirmText="Закрыть"
            />
    </div>
  )
}